import H_act from '@/helpers/act';
import H_time from '@/helpers/time';
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';
import H_guidelineVersion from '@/helpers/guidelineVersion';
import H_guidelineVersionAdmin from '@/helpers/guidelineVersionAdmin';

export default {
  setList(rawDataList, guidelineVersionId) {
    return rawDataList.map(({
      id,
      sequence,
      parent_article_version_id: parentId = '',
      type,
      announce_at,
      effect_at,
      name,
      content,
      rich_content,
      guideline_version,
      guideline_article: {id: articleId, has_versions: hasVersions},
      effects,
      factory_effects,
      article_versions,
      act_version_alls,
      attaches,
      related_guidelines,
      has_audit,
      has_checklist,
      has_guideline_article_version,
      has_guideline_version,
      has_internal_training,
      has_license,
      has_task,
    }) => {
      const baseData = {
        id,
        articleId,
        hasVersions,
        sequence,
        type,
        name,
        content,
        richContent: rich_content ? H_common.formatRichContent(rich_content) : '',
        parentId,
        announceAt: H_time.getDateDashFormat(announce_at),
        effectAt: H_time.getDateDashFormat(effect_at),
        effects: [...effects, ...factory_effects].map(item => ({...item, color: 'red'})),
        lawCardList: H_guidelineVersion.setLawCardList({act_version_alls, article_versions}),
        isUpdated: guideline_version.id === guidelineVersionId,
        attaches: H_file.setShowInModule(attaches),
        guidelineList: H_guidelineVersionAdmin.setShowRelatedGuideline(related_guidelines),
        hasRelatedDoc: H_act.hasRelatedDoc({
          has_audit,
          has_checklist,
          has_guideline_article_version,
          has_guideline_version,
          has_internal_training,
          has_license,
        }),
        has_audit,
        has_checklist,
        has_guideline_article_version,
        has_guideline_version,
        has_internal_training,
        has_license,
        has_task,
      };
      return baseData;
    })
  },
  setIndexAnnounceDropdown(rawDataList) {
    const allItems = rawDataList.map(({id, announce_at}) => {return {id, textLabel: H_time.getDateDashFormat(announce_at)}});
    return {
      selectedItem: rawDataList[0].id,
      items: allItems.slice(0, allItems.length -1),
      allItems,
    };
  },
  setPickGuidelineList(rawDataList, selectedArticleList) {
    return rawDataList.map(({
      id,
      sequence,
      parent_article_version_id: parentId = '',
      type,
      announce_at,
      effect_at,
      name,
      content,
      rich_content,
      guideline_article: {id: articleId, has_versions: hasVersions},
      effects,
      factory_effects,
      article_versions,
      act_version_alls,
      attaches,
      no_text,
      related_guidelines,
      has_audit,
      has_checklist,
      has_guideline_article_version,
      has_guideline_version,
      has_internal_training,
      has_license,
      has_task,
    }) => ({
      id,
      articleId,
      hasVersions,
      sequence,
      type,
      name: name || no_text,
      content,
      richContent: rich_content ? H_common.formatRichContent(rich_content) : '',
      parentId,
      announceAt: H_time.getDateDashFormat(announce_at),
      effectAt: H_time.getDateDashFormat(effect_at),
      effects: [...effects, ...factory_effects].map(item => ({...item, color: 'red'})),
      lawCardList: H_guidelineVersion.setLawCardList({act_version_alls, article_versions}),
      attaches: H_file.setShowInModule(attaches),
      isChecked: selectedArticleList.some(item => item.id === id),
      checkboxDisable: false,
      guidelineList: H_guidelineVersionAdmin.setShowRelatedGuideline(related_guidelines),
      hasRelatedDoc: H_act.hasRelatedDoc({
        has_audit,
        has_checklist,
        has_guideline_article_version,
        has_guideline_version,
        has_internal_training,
        has_license,
      }),
      has_audit,
      has_checklist,
      has_guideline_article_version,
      has_guideline_version,
      has_internal_training,
      has_license,
      has_task,
    }));
  },
}